import React from 'react';
import { ClockIcon, CurrencyDollarIcon } from '@heroicons/react/24/outline';

interface ServiceCardProps {
  id: string;
  name: string;
  description?: string;
  price: number;
  duration: number;
  category?: string;
  onClick: () => void;
}

const ServiceCard: React.FC<ServiceCardProps> = ({
  name,
  description,
  price,
  duration,
  category,
  onClick,
}) => {
  return (
    <div
      onClick={onClick}
      className="cursor-pointer rounded-lg border-2 p-6 transition-all duration-200 hover:shadow-lg hover:scale-[1.02] border-gray-200 dark:border-slate-700 bg-white dark:bg-slate-800 hover:border-brand-400 dark:hover:border-brand-600"
    >
      {/* 類別標籤 */}
      {category && (
        <div className="mb-3">
          <span className="inline-block px-3 py-1 text-xs font-semibold rounded-full bg-gray-100 dark:bg-slate-700 text-gray-700 dark:text-gray-300">
            {category}
          </span>
        </div>
      )}

      {/* 服務名稱 */}
      <h3 className="text-xl font-bold text-gray-900 dark:text-white mb-2">
        {name}
      </h3>

      {/* 描述 */}
      {description && (
        <p className="text-sm text-gray-600 dark:text-gray-400 mb-4 line-clamp-2">
          {description}
        </p>
      )}

      {/* 價格和時長 */}
      <div className="flex items-center justify-between mt-4">
        <div className="flex items-center space-x-1 text-brand-600 dark:text-brand-400">
          <CurrencyDollarIcon className="h-5 w-5" />
          <span className="text-lg font-bold">${Math.floor(price)}</span>
        </div>

        <div className="flex items-center space-x-1 text-gray-600 dark:text-gray-400">
          <ClockIcon className="h-5 w-5" />
          <span className="text-sm font-medium">{duration} 分鐘</span>
        </div>
      </div>
    </div>
  );
};

export default ServiceCard;
